module.exports = __webpack_public_path__ + "static/Chip-9630d059de99f304792ae5f9b3198f6e.svg";